import { API_BASE_URL } from '../services/api'

/**
 * Image URLs in the AST are stored as canonical, origin-less paths (e.g. `/api/books/:id/images/:imageId`)
 * so the same AST works across dev/prod. The browser, however, needs an absolute URL when the API lives
 * on a different origin than the SPA (Vite dev: 3000 vs 5001; Render prod: static site vs API service).
 * This helper glues the API origin onto API-relative paths and leaves everything else untouched.
 */
export function resolveImageUrl(url: string): string {
  if (!url) {
    return url
  }
  if (url.startsWith('/api/')) {
    return `${API_BASE_URL}${url}`
  }
  return url
}
